// Unknown external effects of a project (decision D41-B2, PRD AC08; apps/api/src/routes/external-operations.ts). An
// effect whose outcome is unknown is never replayed; an organization admin records what happened on the remote system.
import type { ExternalOperationResolution, ExternalOperationResolutionRequest, ExternalOperationView } from "@maestros/contracts";
import { api } from "./client.ts";

const enc = encodeURIComponent;

export const listUnknownExternalOperations = (projectId: string, signal: AbortSignal) =>
  api<ExternalOperationView[]>(`/projects/${enc(projectId)}/external-operations`, { query: { state: "unknown" }, signal });

export interface ResolutionInput {
  outcome: ExternalOperationResolution;
  note: string;
  /** Provider identifier of the effect (done only); empty means none. */
  externalRef: string;
}

/** The body the API validates. `confirmed` is always true: the dialog asked the person before this is built. */
export function resolutionBody({ outcome, note, externalRef }: ResolutionInput): ExternalOperationResolutionRequest {
  const ref = externalRef.trim();
  return {
    outcome,
    note: note.trim(),
    ...(outcome === "done" && ref !== "" ? { external_ref: ref } : {}),
    confirmed: true,
  };
}

export const resolveExternalOperation = (id: string, body: ExternalOperationResolutionRequest) =>
  api<ExternalOperationView>(`/external-operations/${enc(id)}/resolution`, { method: "POST", body });
